<template>
  <div class="mt-6">
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="mt-6">
        <v-card elevation="6">
          <div class="pa-4">
            <span style="font-size: 24px">รายละเอียดการนับสต๊อก</span>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="detailHeader" :items="get_details" :footer-props="footer_Props" :loading="loading_table" :items-per-page.sync="item_page" :search="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div v-if="dataDetail.item.product_code != null">{{ dataDetail.item.product_code }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td class="text-center">{{ format_number(dataDetail.item.quantity) }}</td>
                  <td> {{ dataDetail.item.unit_name }}</td>
                  <td>
                    <div>{{ format_number(dataDetail.item.quantity_count) }}</div>
                    <!--                    <div v-else>0</div>-->
                  </td>
                  <td class="text-center">
                    <div v-if="dataDetail.item.before_change < 0" style="color: red">{{ format_number(dataDetail.item.before_change) }}</div>
                    <div v-if="dataDetail.item.before_change === 0">0</div>
                    <div v-if="dataDetail.item.before_change > 0" style="color: #86bc3a">{{ format_number(dataDetail.item.before_change) }}</div>
                  </td>
                  <td class="text-center">
                    <div v-if="dataDetail.item.confirm_count < 0" style="color: red">{{ format_number(dataDetail.item.confirm_count) }}</div>
                    <div v-if="dataDetail.item.confirm_count === 0">0</div>
                    <div v-if="dataDetail.item.confirm_count == null">-</div>
                    <div v-if="dataDetail.item.confirm_count > 0" style="color: #86bc3a">{{ format_number(dataDetail.item.confirm_count) }}</div>
                  </td>
                  <td>{{ dataDetail.item.user_name }}</td>
                  <!--                  <td>{{ dataDetail.item.note }}</td>-->
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Warehouse_detail",
  data() {
    return {
      loading_page: false,
      search: null,
      sortBy: '',
      sortDesc: false,
      loading_table: false,
      get_details: [],
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      detailHeader: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวนคงคลัง',
          value: 'quantity',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วย',
          value: 'unit_name',
          fixed: true,
          width: '100px',
        },
        {
          text: 'นับได้',
          value: 'quantity_count',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนต่างก่อนปรับ',
          value: 'before_change',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ส่วนต่างหลังปรับ',
          value: 'confirm_count',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ผู้ปรับส่วนต่าง',
          value: 'user_name',
          fixed: true,
          width: '200px',
        },
      ],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    getStock_deatail() {
      this.loading_page = true
      this.loading_table = true
      HTTP.post('/inventory/counts/getproductinstock', {
        stock_id: this.$route.params.idpromotionadd
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.loading_table = false
          this.get_details = res.data.object
        }
      })
    }
  },
  mounted() {
    this.getStock_deatail();
  }
}
</script>

<style scoped>

</style>
